/*
 * Import all exported colors from colors.less and
 * re-export them explicitly as strings since Typescript
 * will have no knowledge of what we're importing here
 */
const colors = require('./colors.less');

export * from './utils';

export const N0: string = colors.N0;
export const N10: string = colors.N10;
export const N20: string = colors.N20;
export const N30: string = colors.N30;
export const N40: string = colors.N40;
export const N50: string = colors.N50;
export const N60: string = colors.N60;
export const N70: string = colors.N70;
export const N80: string = colors.N80;
export const N90: string = colors.N90;

export const N100: string = colors.N100;
export const N200: string = colors.N200;
export const N300: string = colors.N300;
export const N400: string = colors.N400;
export const N500: string = colors.N500;
export const N600: string = colors.N600;
export const N700: string = colors.N700;
export const N800: string = colors.N800;
export const N900: string = colors.N900;

export const N10A: string = colors.N10A;
export const N20A: string = colors.N20A;
export const N30A: string = colors.N30A;
export const N40A: string = colors.N40A;
export const N50A: string = colors.N50A;
export const N60A: string = colors.N60A;
export const N70A: string = colors.N70A;
export const N80A: string = colors.N80A;
export const N90A: string = colors.N90A;

export const N100A: string = colors.N100A;
export const N200A: string = colors.N200A;
export const N300A: string = colors.N300A;
export const N400A: string = colors.N400A;
export const N500A: string = colors.N500A;
export const N600A: string = colors.N600A;
export const N700A: string = colors.N700A;
export const N800A: string = colors.N800A;

export const TrelloBlue50: string = colors['trello-blue-50'];
export const TrelloBlue100: string = colors['trello-blue-100'];
export const TrelloBlue200: string = colors['trello-blue-200'];
export const TrelloBlue300: string = colors['trello-blue-300'];
export const TrelloBlue400: string = colors['trello-blue-400'];
export const TrelloBlue500: string = colors['trello-blue-500'];
export const TrelloBlue600: string = colors['trello-blue-600'];
export const TrelloBlue700: string = colors['trello-blue-700'];
export const TrelloBlue800: string = colors['trello-blue-800'];
export const TrelloBlue900: string = colors['trello-blue-900'];

export const Green50: string = colors['green-50'];
export const Green100: string = colors['green-100'];
export const Green200: string = colors['green-200'];
export const Green300: string = colors['green-300'];
export const Green400: string = colors['green-400'];
export const Green500: string = colors['green-500'];
export const Green600: string = colors['green-600'];
export const Green700: string = colors['green-700'];
export const Green800: string = colors['green-800'];
export const Green900: string = colors['green-900'];

export const Orange50: string = colors['orange-50'];
export const Orange100: string = colors['orange-100'];
export const Orange200: string = colors['orange-200'];
export const Orange300: string = colors['orange-300'];
export const Orange400: string = colors['orange-400'];
export const Orange500: string = colors['orange-500'];
export const Orange600: string = colors['orange-600'];
export const Orange700: string = colors['orange-700'];
export const Orange800: string = colors['orange-800'];
export const Orange900: string = colors['orange-900'];

export const Red50: string = colors['red-50'];
export const Red100: string = colors['red-100'];
export const Red200: string = colors['red-200'];
export const Red300: string = colors['red-300'];
export const Red400: string = colors['red-400'];
export const Red500: string = colors['red-500'];
export const Red600: string = colors['red-600'];
export const Red700: string = colors['red-700'];
export const Red800: string = colors['red-800'];
export const Red900: string = colors['red-900'];

export const Yellow50: string = colors['yellow-50'];
export const Yellow100: string = colors['yellow-100'];
export const Yellow200: string = colors['yellow-200'];
export const Yellow300: string = colors['yellow-300'];
export const Yellow400: string = colors['yellow-400'];
export const Yellow500: string = colors['yellow-500'];
export const Yellow600: string = colors['yellow-600'];
export const Yellow700: string = colors['yellow-700'];
export const Yellow800: string = colors['yellow-800'];
export const Yellow900: string = colors['yellow-900'];

export const Purple50: string = colors['purple-50'];
export const Purple100: string = colors['purple-100'];
export const Purple200: string = colors['purple-200'];
export const Purple300: string = colors['purple-300'];
export const Purple400: string = colors['purple-400'];
export const Purple500: string = colors['purple-500'];
export const Purple600: string = colors['purple-600'];
export const Purple700: string = colors['purple-700'];
export const Purple800: string = colors['purple-800'];
export const Purple900: string = colors['purple-900'];

export const Pink50: string = colors['pink-50'];
export const Pink100: string = colors['pink-100'];
export const Pink200: string = colors['pink-200'];
export const Pink300: string = colors['pink-300'];
export const Pink400: string = colors['pink-400'];
export const Pink500: string = colors['pink-500'];
export const Pink600: string = colors['pink-600'];
export const Pink700: string = colors['pink-700'];
export const Pink800: string = colors['pink-800'];
export const Pink900: string = colors['pink-900'];

export const Sky50: string = colors['sky-50'];
export const Sky100: string = colors['sky-100'];
export const Sky200: string = colors['sky-200'];
export const Sky300: string = colors['sky-300'];
export const Sky400: string = colors['sky-400'];
export const Sky500: string = colors['sky-500'];
export const Sky600: string = colors['sky-600'];
export const Sky700: string = colors['sky-700'];
export const Sky800: string = colors['sky-800'];
export const Sky900: string = colors['sky-900'];

export const Lime50: string = colors['lime-50'];
export const Lime100: string = colors['lime-100'];
export const Lime200: string = colors['lime-200'];
export const Lime300: string = colors['lime-300'];
export const Lime400: string = colors['lime-400'];
export const Lime500: string = colors['lime-500'];
export const Lime600: string = colors['lime-600'];
export const Lime700: string = colors['lime-700'];
export const Lime800: string = colors['lime-800'];
export const Lime900: string = colors['lime-900'];

export const BusinessBlue50: string = colors['business-blue-50'];
export const BusinessBlue100: string = colors['business-blue-100'];
export const BusinessBlue200: string = colors['business-blue-200'];
export const BusinessBlue300: string = colors['business-blue-300'];
export const BusinessBlue400: string = colors['business-blue-400'];
export const BusinessBlue500: string = colors['business-blue-500'];
export const BusinessBlue600: string = colors['business-blue-600'];
export const BusinessBlue700: string = colors['business-blue-700'];
export const BusinessBlue900: string = colors['business-blue-900'];
export const BusinessBlue800: string = colors['business-blue-800'];



// WEBPACK FOOTER //
// ./app/common/lib/colors/index.ts